import React from 'react';
import { Typography, Space, Popconfirm, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { DeleteOutlined } from '@ant-design/icons';
import EntryCard from '../EntryCard/EntryCard';
import ContentCard from '../ContentCard/ContentCard';

const { Text } = Typography;

const BusinessInfoEntryItem = ({ entry, onDelete }) => {
    const { t } = useTranslation();

    return (
        <EntryCard>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Flex justify="flex-end">
                    <Popconfirm
                        title={t('delete_this_entry')}
                        onConfirm={() => onDelete(entry.id)}
                        okText={t('yes')}
                        cancelText={t('no')}
                    >
                        <DeleteOutlined
                            style={{ 
                                fontSize: 16, 
                                color: '#ff4d4f',
                                cursor: 'pointer'
                            }}
                        />
                    </Popconfirm>
                </Flex>
                <ContentCard type="business">
                    <Text style={{ fontSize: 13 }}>
                        {entry.content}
                    </Text>
                </ContentCard>
            </Space>
        </EntryCard>
    );
};

export default BusinessInfoEntryItem; 